





















import Vue from 'vue'
import HelloWorld from '@/components/HelloWorld.vue'

export default Vue.extend({
  name: 'home',
  data() {
    return {
      updates: [
        `[4.1]: 🔥Mars and ⚡️Zeus have come!`,
        `[6.2]: Dazzle, WinterWyvern and Sven have come!`,
      ],
    }
  },
})
